export default "__VITE_ASSET__BBr2QuTb__"